import summaryIcon from "../../../../assets/summary.png";
import React, { useState, useContext, useEffect } from "react";
import { DollarContext } from "../../../../contexts/DollarContext";
import usePrevisionsStore from "../../../../store/previsionsStore";
import useProductStore from "../../../../store/productStore";
import TaxesSimulations from "../../../../components/TaxesSimulations";
import { formatarValor } from "../../../../components/OrderTable";
import CostOverviewSimulation from "../../../../components/CostOverviewSimulation";
import OrderProductsTableSimulation from "../../../../components/OrderProductsTableSimulation";
import api from "../../../../services/api";
import { useParams } from "react-router-dom";

const DetalhesSimulacao = () => {
  const dollarPriceToday = useContext(DollarContext);
  const dollarInFloat = parseFloat(
    dollarPriceToday?.replace("R$", "")?.replace(",", ".")
  );
  const [simulation, setSimulation] = useState({});
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchSimulation = async () => {
      try {
        setIsLoading(true);
        const response = await api.get(`/simulations/${id}`);
        setSimulation(response.data);
      } catch (error) {
        console.log("Erro ao obter simulação: ", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchSimulation();
  }, [id]);

  if (isLoading) return <p>Carregando...</p>;

  return (
    <>
      <div className="grid grid-cols-3 gap-6">
        <div className="flex flex-col gap-2">
          <strong className="text-gray-800 font-semibold">Nome</strong>
          <input
            className="rounded-md bg-gray-200 py-2 px-4  outline-none"
            value={simulation.name || ""}
            readOnly
          />
        </div>
        <div className="flex flex-col gap-2">
          <strong className="text-gray-800 font-semibold">
            Frete Marítimo
          </strong>
          <input
            className="rounded-md bg-gray-200 py-2 px-4 text-right outline-none"
            placeholder="$ 0,00"
            value={"$ " + simulation.maritime_freight_value}
            readOnly
          />
        </div>

        <div className="flex flex-col gap-2">
          <strong className="text-gray-800 font-semibold">
            Frete Terrestre
          </strong>
          <input
            className="rounded-md bg-gray-200 py-2 px-4 text-right outline-none"
            placeholder="R$ 0,00"
            value={"R$ " + simulation.land_freight_value}
            readOnly
          />
        </div>

        <div className="flex flex-col gap-2">
          <strong className="text-gray-800 font-semibold">Outras Taxas</strong>
          <input
            className="rounded-md bg-gray-200 py-2 px-4 text-right outline-none"
            placeholder="$ 0,00"
            value={"$ " + simulation.another_tax_value}
            readOnly
          />
        </div>
        <div className="flex flex-col gap-2">
          <strong className="text-gray-800 font-semibold">Previsão</strong>
          <input
            className="rounded-md bg-gray-200 py-2 capitalize px-4 text-center outline-none"
            placeholder="$ 0,00"
            value={simulation.prevision_name}
            readOnly
          />
        </div>

        {/* Seção de resumo da simulação */}
        <div className="bg-[#F9F9F9] my-4 md:p-2 xl:p-4 flex w-full col-span-3">
          <div className="w-full text-[#2F2E41] opacity-80 flex">
            <div className="py-2 text-[#2F2E41] opacity-80 flex flex-grow">
              <div className="flex justify-center items-center xl:px-4 md:px-2">
                <img
                  className="md:w-[40px] md:h-[50px] xl:w-[50px] xl:h-[60px]"
                  src={summaryIcon}
                  alt="Resumo"
                />
              </div>
              <div className="cursor-pointer">
                <p className="md:base xl:text-2xl">Simulação do pedido</p>
              </div>
            </div>

            <div className="text-center flex justify-between items-center flex-grow">
              <div>
                <p className="uppercase font-bold md:text-sm xl:text-base">
                  {simulation.cbm}{" "}
                  <span className="text-[#FF9533] md:text-xs">CBM</span>
                </p>
                <p className="uppercase font-bold md:text-sm xl:text-base">
                  {simulation.weight}{" "}
                  <span className="text-[#FF9533] md:text-xs">KG</span>
                </p>
              </div>
              <div>
                <p className="uppercase text-[#FF9533] md:text-xs font-bold">
                  Quantidade
                </p>
                <p className="md:text-sm xl:text-base">
                  {simulation.container_quantity}
                </p>
              </div>
              <div>
                <p className="uppercase text-[#FF9533] md:text-xs font-bold">
                  Total Alvo
                </p>
                <p className="md:text-sm xl:text-base">
                  {formatarValor(simulation.total_target)}
                </p>
              </div>
              <div>
                <p className="uppercase text-[#FF9533] md:text-xs font-bold">
                  Total Un.
                </p>
                <p className="md:text-sm xl:text-base">
                  {formatarValor(simulation.total_unit)}
                </p>
              </div>
              <div>
                <p className="uppercase text-[#FF9533] md:text-xs font-bold">
                  Total pedido
                </p>
                <p className="md:text-xs xl:text-base">
                  {formatarValor(simulation.total_target)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Componentes de exibição de taxas e custos */}
      <TaxesSimulations
        cofinsFromApi={simulation.cofins}
        icmsFromApi={simulation.icms}
        iiFromApi={simulation.ii}
        ipipasepFromApi={simulation.ipi}
        pisFromApi={simulation.pis}
        afrmmFromApi={simulation.afrmm_tax_value}
        otherShippingExpenses={simulation.other_shipping_expenses_value}
        storageValue={simulation.storage_value}
        customClearanceValue={simulation.customs_clearance_value}
        otherExpensesValue={simulation.other_expenses}
        freightCollectValue={simulation.freight_collect_value}
        dollarInFloat={dollarInFloat}
      />

      <CostOverviewSimulation
        title={"Simulação de gastos"}
        impostos={simulation.total_tax_value}
        valueTotal={simulation.logistics_value + simulation.total_tax_value}
        logistica={simulation.logistics_value}
      />

      <OrderProductsTableSimulation
        transporte={Number(
          simulation.maritime_freight_value * dollarInFloat +
            simulation.freight_collect_value * dollarInFloat +
            simulation.other_shipping_expenses_value * dollarInFloat +
            simulation.land_freight_value
        )}
        outrosCustos={Number(
          simulation.afrmm_tax_value * dollarInFloat +
            simulation.storage_value * dollarInFloat +
            simulation.other_expenses * dollarInFloat +
            simulation.customs_clearance_value * dollarInFloat +
            simulation.another_tax_value * dollarInFloat
        )}
        dollarInFloat={dollarInFloat}
        orderLoadItems={simulation.order_load_items || []}
      />
    </>
  );
};

export default DetalhesSimulacao;
